import {Spinner} from '@/components/ui/spinner/Spinner'
import {useTranslation} from 'react-i18next'
import {
    PurchaseBox,
    StyleMicromorgiIcon,
    StyledAmount,
    StyledAmountContainer,
    StyledPackPrice,
    StyledButtonBox,
    StyledPackContainer,
    StyledPackPriceBox,
    StyledDivider
} from './style'
import {Button} from '@/components/ui/button/Button'
import {useMe} from '@/features/authentication/queries/useMe'
import {userStatuses} from '@/components/ui/chatBadge/ChatBadge'
import {GuestTypeV3} from '@/features/authentication/types'
import {remapCurrency} from '@/features/profile/constants'
import {useFetchMicromorgiPackagesV3} from '@/features/gift/queries/useFetchMicromorgiPackagesV3'
import {MicromorgiPackageV3} from '@/features/gift/buy-morgis-modal/BuyMorgisModal'

type RenderPurchaseStepProps = {
    selectedOption?: MicromorgiPackageV3
    findSelectedOption: (pack: MicromorgiPackageV3) => boolean
    selectPackClick: (pack: MicromorgiPackageV3) => void
    handleBuyMicromorgiPackage: (packageId: string) => void
}

export const RenderPurchaseStep = ({
    handleBuyMicromorgiPackage,
    selectedOption,
    findSelectedOption,
    selectPackClick
}: RenderPurchaseStepProps) => {
    const {t} = useTranslation()
    const {data} = useMe()
    const user = data as GuestTypeV3

    const userStatus = user?.typeAttributes.levelStatus as string

    const {data: micromorgiPackages, isLoading} = useFetchMicromorgiPackagesV3()

    const filteredMicromorgiPackagesByStatus = micromorgiPackages?.filter(
        micromorgiPackage =>
            micromorgiPackage.levelStatus === (userStatus === userStatuses.SILVER ? userStatuses.GUEST : userStatus)
    )

    return (
        <>
            {isLoading ? (
                <Spinner inline size={30} />
            ) : (
                <div>
                    <StyledPackPriceBox>
                        <StyledPackPrice>{t('riched_limit_modal:description')}</StyledPackPrice>
                    </StyledPackPriceBox>
                    <PurchaseBox>
                        {filteredMicromorgiPackagesByStatus?.map(pack => (
                            <StyledPackContainer
                                onClick={() => selectPackClick(pack)}
                                selected={findSelectedOption(pack)}
                                key={pack.id}
                            >
                                <StyledAmountContainer>
                                    <StyleMicromorgiIcon />
                                    <StyledAmount>{pack.micromorgiCount}</StyledAmount>
                                </StyledAmountContainer>
                                <div>
                                    <StyledPackPrice>
                                        {t('riched_limit_modal:pricing', {
                                            CURRENCY: remapCurrency[user.currency],
                                            MICROMorgis_COUNT: pack.micromorgiCount,
                                            PRICE: pack.price
                                        })}
                                    </StyledPackPrice>
                                </div>
                            </StyledPackContainer>
                        ))}
                        <StyledDivider />
                    </PurchaseBox>
                    <StyledButtonBox>
                        <Button
                            disabled={!selectedOption}
                            onClick={() => selectedOption && handleBuyMicromorgiPackage(`${selectedOption.id}`)}
                        >
                            {t('riched_limit_modal:purchase_now_button')}
                        </Button>
                    </StyledButtonBox>
                </div>
            )}
        </>
    )
}
